export default "__VITE_ASSET__BIMCMuaf__"